<template>
    <q-layout v-if="!initalLoad" view="hhh lpR fff">
        <Header :clear="clearSearch" @search-cleared="clearSearch = false" />
        <Main>
            <transition name="fade" mode="out-in">
                <router-view @clear-search="clearSearch = true" />
            </transition>
            <q-dialog
                v-model="dialogShow"
                position="top"
                style="max-width: fit-content"
                @input="hideDialog"
            >
                <q-card width="100%">
                    <q-card-section class="row items-center no-wrap">
                        <q-icon name="info_outline" size="30px"></q-icon>
                        <div class="text-grey-bold q-px-sm">
                            {{ dialogMessage }}
                        </div>
                    </q-card-section>
                </q-card>
            </q-dialog>
        </Main>
        <Footer />
    </q-layout>
</template>

<script>
import Header from './layout/Header.vue'
import Main from './layout/Main.vue'
import Footer from './layout/Footer.vue'
import store from '@/store'
import currencies from '@/local-shared/mixins/currencies'
import locales from '@/local-shared/mixins/locales'

export default {
    name: 'App',

    components: {
        Header,
        Main,
        Footer,
    },
    mixins: [locales, currencies],

    data() {
        return {
            initalLoad: true,
            clearSearch: false,
        }
    },

    computed: {
        dialogShow: {
            get: function () {
                return store.getters['dialog/show']
            },

            set: function () {
                this.$store.commit('dialog/showDialog')
            },
        },

        dialogMessage() {
            return store.getters['dialog/message']
        },
    },

    created() {
        // store.dispatch('cart/updateLibary', [])
        this.showLoading()
    },

    mounted() {
        this.timer = setTimeout(() => {
            this.hideLoading()
        }, 1000)
    },

    methods: {
        showLoading() {
            this.$q.loading.show({
                message: this.$t('loadings.loading_page'),
            })
        },

        hideLoading() {
            this.initalLoad = false
            this.timer = setTimeout(() => {
                this.$q.loading.hide()
                this.timer = void 0
            }, 1000)
        },

        hideDialog() {
            this.$store.commit('dialog/hideDialog')
        },
    },
}
</script>
